export default __webpack_public_path__ + "static/media/image10.b7282849.svg";